module.exports = __webpack_public_path__ + "fa-solid-900.e8a427e15cc502bef99c.woff2";


//////////////////
// WEBPACK FOOTER
// E:/xampp/htdocs/liberado/CocoraSMFront/src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/plugins/fontawesome-free/webfonts/fa-solid-900.woff2
// module chunks = styles